"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TILE_DEFAULTS = {
  TITLE_COLOR: 'neutral',
  SUBTITLE_COLOR: 'greyDark',
  BACKGROUND_COLOR: 'default',
  HOVER_BACKGROUND_COLOR: 'primary',
  ACTIVE_BORDER_COLOR: 'secondary'
};
var _default = TILE_DEFAULTS;
exports.default = _default;